import { Routes } from '@angular/router';
import { ViewPlansComponent } from "./view-plans.component";

export const ViewPlansRoutes: Routes = [
    { path: '', component: ViewPlansComponent, pathMatch: 'full' }
];

